import React from 'react';
import { useEffect, useState } from "react"
import ToolBlockHorizontal from '../tool-block-horizontal/tool-block-horizontal';
import { SPORT_BASE } from '../../javascript/services/globalVars';
import useIsLandscape from '../../javascript/utils/use-is-landscape.js';
import $ from 'jquery';
import style from './score-toolbar-style.module.scss';

// import ToolbarBtn from './toolbar-btn/toolbar-btn';                // Deprecate these
// import ToolbarButtons from '../../javascript/sport/toolbarBtns';   // Deprecate these

function ScoreToolbar(Props) {
   const isLandscape = useIsLandscape();
   const [pinState, setPinState] = useState(false);
   const [toolBlock, setToolBlock] = useState([]);
   const [pinTextState, setPinTextState] = useState('Pin');
   const pinBtnClass = style.toolbarPinBtnWrap;

   let styleVisible = '';
   if (Props.state === 1) {
      styleVisible = style.isVisible;
   }

   const pinBtn = () => {
      if (pinState) {
         setPinState(false);
         setPinTextState('Pin');
         localStorage.setItem("sme-scoring-app_pin_menu", "false");
      } else {
         setPinState(true);
         setPinTextState('Unpin');
         localStorage.setItem("sme-scoring-app_pin_menu", "true");
      }
   }

   const offElementClick = () => {
      $(document).on('click', (e) => {
         // >>> Closes Menu on button click
         if ($(e.target).closest('.Btn_toolSolid').length === 1) {
            if (typeof Props.closeCallback === 'function') {
               const pingText = $('.' + pinBtnClass).text();
               if (pingText === 'Pin') {
                  Props.closeCallback();
               }
            }
         }
         
         if (!$(e.target).closest(`.${style.toolbarWrap}, .${style.toolbarBtnWrap}, .SideMenuBtn`).length) {
            if (typeof Props.closeCallback === 'function') {
               const pingText = $('.' + pinBtnClass).text();
               if (pingText === 'Pin') {
                  Props.closeCallback();
               }
            }
         }
      });
   }

   useEffect(() => {
      setToolBlock(SPORT_BASE.sport_object.tool_blocks.game_menu); 
   }, [])

   useEffect(() => {
      offElementClick();

      const pinMenu = localStorage.getItem("sme-scoring-app_pin_menu");
      if (pinMenu === "true") {
         pinBtn();
         if (typeof Props.openCallback === 'function') {
            Props.openCallback();
         }
      }

      return () => {
         $('document').off('click');
      };
   }, []);

   
   return (
      <div className={`${isLandscape ? style.toolbarWrap : style.toolbarWrapPortrait} ${styleVisible}`} >
 
         <div className={style.toolbarBtnWrap}>
            <ToolBlockHorizontal tool_block={toolBlock} />
         </div>
         <div className={pinBtnClass} onClick={pinBtn} >
            <span>
               {pinTextState}
            </span>
         </div>
      </div>
   );
}

export default ScoreToolbar;